import script from "./InvestimentosCompartilhadosFormView.vue?vue&type=script&setup=true&lang=js"
export * from "./InvestimentosCompartilhadosFormView.vue?vue&type=script&setup=true&lang=js"

import "./InvestimentosCompartilhadosFormView.vue?vue&type=style&index=0&id=6fa2b374&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6fa2b374"]])

export default __exports__